import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref } from "vue"

const _hoisted_1 = { class: "box___file-uploader" }
const _hoisted_2 = { class: "container___file-uploader" }
const _hoisted_3 = { class: "content___uploader column" }
const _hoisted_4 = { class: "display___uploader" }
const _hoisted_5 = { class: "px-2" }
const _hoisted_6 = {
  key: 1,
  class: "box___insert-url"
}
const _hoisted_7 = { class: "my-1" }
const _hoisted_8 = {
  key: 0,
  class: "bg___uploader"
}
const _hoisted_9 = {
  key: 0,
  class: "box___image"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "hint___image-dimension"
}
const _hoisted_12 = {
  key: 1,
  class: "bg___diabled"
}
const _hoisted_13 = { class: "box___error-message" }
const _hoisted_14 = { key: 0 }

import { computed, onMounted, ref, watch } from 'vue';
import IconUpload from '@/components/icons/IconUpload.vue';
import { file } from '@babel/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseFileUploader',
  props: {
    modelValue: { default: undefined },
    fileUrl: { default: '' },
    fileExtensions: { default: '' },
    isImageUploader: { type: Boolean, default: false },
    isAllowFileUrl: { type: Boolean, default: false },
    minWidth: { default: 0 },
    minHeight: { default: 0 },
    disabled: { type: Boolean, default: false },
    maxFileSize: { default: 0 },
    errorMessage: { default: '' }
  },
  emits: ['update:modelValue', 'update:file-url', 'update-image-dimension', 'is-validate'],
  setup(__props: any, { emit }) {

const props = __props as { modelValue: any, fileUrl: string, fileExtensions: string, isImageUploader: boolean, isAllowFileUrl: boolean, minWidth: number, minHeight: number, disabled: boolean, maxFileSize: number, errorMessage: string }





const errorMessageDisplay = computed(() => {
  if (props.isImageUploader) { //valdiate for images case
    if (selfFileUrl.value !== ''
      && (imageWidth.value === 0 || imageHeight.value === 0)
      && isUploadcomplete.value) { //validate valid image url
      emit('is-validate', false);
      return 'Image url is invalid. Please insert new image url.';
    } else if ((selfValue.value || selfFileUrl.value !== '')
      && (imageWidth.value < props.minWidth
      || imageHeight.value < props.minHeight)
      && isUploadcomplete.value) { //validate image resolution
      emit('is-validate', false);
      return `Image resolution must be at least ${props.minWidth}px and ${props.minHeight}px`;
    } else if ((selfFileUrl.value || selfFileUrl.value !== '')
      && imageDisplay.value === '') {
      emit('is-validate', false);
      return 'Unable to get image';
    } else if (!validateImageUrlFormat()
      || (selfFileUrl.value.includes('data:image')
      && selfFileUrl.value.includes(';base64'))) { //validate image file url format
      emit('is-validate', false);
      return 'Image file type is incorrect';
    }
  } else if (props.fileExtensions !== ''
    && selfValue.value
    && !props.fileExtensions.includes(fileType.value.toLowerCase())
    && isUploadcomplete.value) { //validate file format
    emit('is-validate', false);
    return 'File type is incorrect';
  } else if (selfValue.value && props.maxFileSize > 0
    && selfValue.value.size > props.maxFileSize
    && isUploadcomplete.value) { //validate file size limit
    emit('is-validate', false);
    return `File must be less than ${props.maxFileSize}`;
  } else if (externalErrorMessage.value !== '') { //error if there's external error message
    emit('is-validate', false);
    return externalErrorMessage.value;
  }
  emit('is-validate', true);
  return '';
});

const selfValue = ref(props.modelValue);
const selfFileUrl = ref(props.fileUrl);
const imageDisplay = ref('');
const imageWidth = ref(0);
const imageHeight = ref(0);
const fileType = ref('');
const isUploadcomplete = ref(false);
const externalErrorMessage = ref('');

watch(() => [props.modelValue, props.fileUrl, props.errorMessage], ([newModelValue, newFileUrl, newErrorMessage]) => {
  selfValue.value = newModelValue;
  selfFileUrl.value = newFileUrl;
  externalErrorMessage.value = newErrorMessage;
  if (props.isImageUploader && newModelValue) {
    let reader = new FileReader();
    reader.readAsDataURL(newModelValue);
    reader.onload = function (e: any) {
      getImageSourceAndDimension(e.target.result);
    };
    reader.onloadend = function () {
      if (!props.isImageUploader) {
        isUploadcomplete.value = true;
      }
    };
  } else if (props.isImageUploader && newFileUrl) {
    getImageSourceAndDimension(newFileUrl);
  } else if (!newModelValue && !newFileUrl) {
    resetImageDisplay();
  }
});

onMounted(() => {
  if (selfFileUrl.value !== '') {
    getImageSourceAndDimension(selfFileUrl.value);
  }
});

function updateFile() {
  if (props.isAllowFileUrl && selfValue.value) {
    selfFileUrl.value = '';
    emit('update:file-url', selfFileUrl.value);
  }
  if (selfValue.value) {
    const fileTypeArray = selfValue.value.name.split('.');
    fileType.value = fileTypeArray[fileTypeArray.length-1];
    let reader = new FileReader();
    reader.readAsDataURL(selfValue.value);
    reader.onload = function (e: any) {
      getImageSourceAndDimension(e.target.result);
    };
    emit('update:modelValue', selfValue.value);
  }
}
function updateFileUrl() {
  if (selfFileUrl.value !== '') {
    selfValue.value = undefined;
    emit('update:modelValue', selfValue.value);
    getImageSourceAndDimension(selfFileUrl.value);
    emit('update:file-url', selfFileUrl.value);
  } else {
    removeFileUrl();
  }
}
function removeFile() {
  selfValue.value = undefined;
  isUploadcomplete.value = false;
  emit('update:modelValue', selfValue.value);
  if (props.isImageUploader) {
    resetImageDisplay();
  }
}
function removeFileUrl() {
  selfFileUrl.value = '';
  isUploadcomplete.value = false;
  emit('update:file-url', selfFileUrl.value);
  if (props.isImageUploader) {
    resetImageDisplay();
  }
}
function getImageSourceAndDimension(imageSource: string) {
  let img = new Image();
  img.src = imageSource;
  img.onload = function () {
    if (this.complete) {
      imageDisplay.value = imageSource;
      imageWidth.value = this.width;
      imageHeight.value = this.height;
      isUploadcomplete.value = true;
      emit('update-image-dimension', { width: imageWidth.value, height: imageHeight.value });
    }
  };
  img.onerror = function () {
    resetImageDisplay();
  };
}
function resetImageDisplay() {
  imageDisplay.value = '';
  imageWidth.value = 0;
  imageHeight.value = 0;
  isUploadcomplete.value = false;
  emit('update-image-dimension', { width: imageWidth.value, height: imageHeight.value });
}
function validateImageUrlFormat() {
  const fileUrl = selfFileUrl.value.split('.');
  const fileUrlLength = fileUrl.length;
  if (fileUrlLength > 0
    && !props.fileExtensions.includes(fileUrl[fileUrlLength - 1].toLowerCase())) {
    return false;
  }
  return true;
}

return (_ctx: any,_cache: any) => {
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_file_upload = _resolveComponent("va-file-upload")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_input = _resolveComponent("va-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass([
          'box___uploader',
          imageDisplay.value ? 'hidden uploaded' : '',
        ])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_va_file_upload, {
            modelValue: selfValue.value,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((selfValue).value = $event)),
              updateFile
            ],
            "drop-zone-text": _ctx.$t('DRAG-N-DROP-FILE-HERE-OR'),
            "file-types": __props.fileExtensions,
            type: "single",
            "hide-file-list": "",
            dropzone: "",
            disabled: __props.disabled,
            onFileRemoved: removeFile
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(IconUpload, { "class-name": 'icon' }),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('langkey.drag-drop')), 1),
                _createVNode(_component_va_divider, { orientation: "center" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('langkey.or')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_button, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('langkey.btn-upload-file')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "drop-zone-text", "file-types", "disabled"]),
          (selfValue.value)
            ? (_openBlock(), _createBlock(_component_va_button, {
                key: 0,
                icon: "clear",
                size: "small",
                color: "danger",
                onClick: removeFile
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('langkey.remove-file')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (__props.isAllowFileUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('langkey.or')), 1),
                _createVNode(_component_va_input, {
                  modelValue: selfFileUrl.value,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => ((selfFileUrl).value = $event)),
                    updateFileUrl
                  ],
                  placeholder: _ctx.$t('langkey.insert-file-url'),
                  type: "text",
                  disabled: __props.disabled,
                  class: "mb-0",
                  style: {"min-height":"auto"}
                }, {
                  appendInner: _withCtx(() => [
                    (selfFileUrl.value !== '')
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          style: {"cursor":"pointer"},
                          onClick: removeFileUrl
                        }, [
                          _createVNode(_component_va_icon, { name: "close" })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "disabled"])
              ]))
            : _createCommentVNode("", true)
        ]),
        (__props.isImageUploader && imageDisplay.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8))
          : _createCommentVNode("", true)
      ], 2),
      (__props.isImageUploader && imageDisplay.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("img", {
              class: "content___image",
              src: imageDisplay.value
            }, null, 8, _hoisted_10),
            (__props.isImageUploader && imageWidth.value > 0 && imageHeight.value > 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, " Image resolution: " + _toDisplayString(imageWidth.value) + "px x " + _toDisplayString(imageHeight.value) + "px ", 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (__props.disabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_13, [
      (_unref(errorMessageDisplay))
        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t(_unref(errorMessageDisplay))), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})